export default "__VITE_ASSET__BzEXlRHW__"